/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function docReady(fn) {
    // see if DOM is already available
    if (document.readyState === "complete" || document.readyState === "interactive") {
        // call on next available tick
        setTimeout(fn, 1);
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
}  

docReady(function() {
  // DOM is loaded and ready for manipulation here

  const el = document.querySelector('.ProductForm__Variants');
//   console.log(el);
  // New Element
  const newEl = document.createElement("input");
  newEl.setAttribute('name', 'properties[Pre-order]');
  newEl.setAttribute('value', '');
  newEl.setAttribute('type', 'hidden');
  newEl.setAttribute('id', 'pre-order-line-property');
  
  const product = JSON.parse(document.querySelector('script[type="application/json"][data-product-json]').innerHTML);
  console.log(product.inventories);
  
  if(product && product.inventories && product.inventories[product.selected_variant_id] && product.inventories[product.selected_variant_id].inventory_management == "shopify")
  {
    if(product.inventories[product.selected_variant_id].inventory_quantity <= 0){
      
      if (product.inventories[product.selected_variant_id].inventory_policy == "continue"){
        el.after(newEl);
        document.querySelector('#pre-order-line-property').value = 'Item is on pre-order';
        document.querySelector('#preorderbubble').style.display = "block";
        document.querySelector('#product_form_' + product.product.id + ' .ProductForm__AddToCart span').innerHTML = window.languages.productFormPreOrder || 'Pre-Order';
      }
      
    } else {
      document.querySelector('#preorderbubble').style.display = "none";
    }
  }

});

document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant; // Gives you access to the whole variant details
  
  const el = document.querySelector('.ProductForm__Variants');
//   console.log(el);
  // New Element
  const newEl = document.createElement("input");
  newEl.setAttribute('name', 'properties[Pre-order]');
  newEl.setAttribute('value', '');
  newEl.setAttribute('type', 'hidden');
  newEl.setAttribute('id', 'pre-order-line-property');
  
  const preOrderInput = document.querySelector("input[name='properties[Pre-order]']");

  const product = JSON.parse(document.querySelector('script[type="application/json"][data-product-json]').innerHTML);
  console.log(product);
  console.log(product.inventories);
  
  if(product && product.inventories && product.inventories[variant.id] && product.inventories[variant.id].inventory_policy == "deny"){
    document.querySelector('#preorderbubble').style.display = "none";
  }

  if(product && product.inventories && product.inventories[variant.id] && product.inventories[variant.id].inventory_management == "shopify")
  {
    // Pre-order
    if(product.inventories[variant.id].inventory_quantity <= 0)
    {
      if(product.inventories[variant.id].inventory_policy == "continue"){
        el.after(newEl);
        document.querySelector('#pre-order-line-property').value = 'Item is on pre-order';
        document.querySelector('#preorderbubble').style.display = "block";
        document.querySelector('#product_form_' + product.product.id + ' .ProductForm__AddToCart span').innerHTML = window.languages.productFormPreOrder || 'Pre-Order';
      }
      
      if(product.inventories[variant.id].inventory_policy == "deny"){
        document.querySelector('#preorderbubble').style.display = "none";
        preOrderInput.remove();
      }
      
      
    } else {
      // Add to cart
      document.querySelector('#preorderbubble').style.display = "none";
//       preOrderInput.remove();
      document.querySelector('#product_form_' + product.product.id + ' .ProductForm__AddToCart span').innerHTML = window.languages.productFormAddToCart || 'Add to cart';
    }
  }
});


$(document).on("click", '[data-action="add-upsell-to-cart"]', function(e) {    
  e.preventDefault();

  let upsellProductId = $(this).data('variant-id');
  let upsellProductQuantity = $(this).data('variant-quantity');

  addItemToCart(upsellProductId, 1);    // paste your id product number
});

function addItemToCart(variant_id, qty) {
  data = {
    "id": variant_id,
    "quantity": qty
  }

  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() { 
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true  //this code is for prestige theme, is to refresh the cart
      }));
    }
  });
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true    // same code for prestige theme   
  }));
}